import { axiosInstance as axios } from "@/utils/wd_axios.js";
import { userKeys, wdConfigData } from "@/service/wd_app_config.js";

//上传当前文件获取聊天需要的agentUser信息
export const api_create_document_agent_user = (params) => {
    var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
    var requestBody = {
        FileName: params.FileName,
        Content: params.Content
    };
    var url = `${wdConfigData.baseURLApi}/Ppt/FileContent/Upload`;
    return axios.post(url, requestBody, {
        headers: {
            AccessToken: accessToken,
            "Content-Type": "application/json",
        },
    });
};

// 获取/创建 Talk
// Talks/{userId}/{gptUserId}/0/Query
export const api_query_talk = (params) => {
    var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
    var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
    var url = `${wdConfigData.baseURLWordCopilot}/Talks/${user.Id}/${params.gptUserId}/0/Query`;
    return axios.get(url, {
        headers: {
            AccessToken: accessToken,
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
};

// 获取消息列表
// Users/{当前UserId}/Talks/{TalkId}/Messages?start=0&count=3
export const api_get_talk_message_list = (params) => {
    var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
    var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
    var url = `${wdConfigData.baseURLWordCopilot}/Users/${user.Id}/Talks/${params.talkId}/Messages?start=${params.start}&count=${params.count}`;
    return axios.get(url, {
        headers: {
            AccessToken: accessToken,
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
};

// 发送消息
// Talks/{talkId}/Messages/Create
export const api_send_message = (params) => {
    var requestBody = {
        Text: params.promptText,
    };
    var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
    var url = `${wdConfigData.baseURLWordCopilot}/Talks/${params.talkId}/Messages/Create`;
    return axios.post(url, requestBody, {
        headers: {
            AccessToken: accessToken,
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
};